module.exports = __webpack_public_path__ + "static/media/s_v5_t8_2.4b9a80bc.mp3";